export const environment = {
    env: 'TEST',
    production: true,
    API_URL: "https://api-test.easyorderapp.com",
    EMBED_URL: "https://embed-test.easyorderapp.com",
    SAMPLE_RATE: 0.1
};